
import authApiService from "./userApiService";

const handleError = (error) => {
  console.error('API Error:', error);
  return {
    success: false,
    error: error.response?.data?.error || error.message || 'An error occurred',
    statusCode: error.response?.status
  };
};

const handleSuccess = (response) => ({
  success: true,
  data: response.data,
  statusCode: response.status
});

export const bartenderTipoutService = {
  async getBalances() {
    try {
      const response = await authApiService.get("/bartender-tips/balances");
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getEmployees() {
    try {
      const response = await authApiService.get("/bartender-tips/employees");
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getTipHistory(params = {}) {
    try {
      const response = await authApiService.get("/bartender-tips/history", { params });
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async addRecord(data) {
    try {
      const response = await authApiService.post("/bartender-tips/", data);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async updateRecord(id, data) {
    try {
      const response = await authApiService.put(`/bartender-tips/${id}`, data);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async deleteRecord(id) {
    try {
      const response = await authApiService.delete(`/bartender-tips/${id}`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  }
};